import {Component, OnDestroy, OnInit, Type} from '@angular/core';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import {IGetClass, IModalWindow, ISetOptions} from '../../utils/interfaces/modal-dialog.interface';
import {ModalWindowsTypes} from '../../core/enums';

@Component({
    selector: 'asg-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    imports: [NgxSpinnerModule]
})
export class SpinnerComponent implements OnInit, OnDestroy {

  constructor(
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.spinner.show();
  }

  ngOnDestroy() {
    this.spinner.hide();
  }

  getWindowType(): Type<IModalWindow> {
    return SpinnerComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.SPINNER_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | ISetOptions | IGetClass | null {
    switch(type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  getClass(): string {
    return 'spinner-dlg';
  }

}
